module.exports = new __parcel__URL__("reparent-onboarding-dark.ad59f27a.gif").toString();